<h1 mat-dialog-title class="dialog-warning-title">Warning</h1>
<div mat-dialog-content class="dialog-warning-content">
    <p class="dialog-warning-text" [innerHTML]="data.msg"></p>
</div>
<div mat-dialog-actions fxLayoutAlign="center center">
    <button mat-flat-button color="primary" (click)="close()" cdkFocusInitial>
        Ok
    </button>
</div>
